import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=3624cb2b&scoped=true"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"
import style0 from "./TransferModal.vue?vue&type=style&index=0&id=3624cb2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624cb2b",
  null
  
)

export default component.exports